<template>
    <div :key="reRenderKey">        
        <!-- <game-container /> -->
        <pixi-view />
    </div>
</template>

<script>
// import {mapGetters, mapMutations, mapActions} from 'vuex';
// import * as types from '@/store/types';
// import VuexMediator from '@/store/vuexMediator'

// import EventBus from '@/eventBus'
// import Constants from '@/data/constants';

// import WebSocket from '@/communication/websocket';
// import axios from 'axios'

// import moment from 'moment';
// const _ = require('lodash');

// import GameContainer from '@/components/game/GameContainer.vue'
import PixiView from '@/components/pixi/PixiView.vue'

export default { 
    props: [
        // "items"
    ],
    data() {
        return {
            reRenderKey: 0,
        };
    },
    mounted: function () {
    },
    methods: {
        // ...mapActions({
        //     readItemAsync: types.READ_ITEM_ASYNC,
        // }),
        // ...mapMutations({
        //     setItem: types.SET_ITEM,
        // }),
        forceRerender() {
            this.reRenderKey += 1;  
        },         
    },
    computed: {
        // ...mapGetters({
        //     GET_USER:       types.GET_USER,
        //     GET_APP_STATE:  types.GET_APP_STATE,
        // }),
        // someComputed: function () {
        //     return someValue;
        // },
    },
    components: {
        // GameContainer,
        PixiView,
    },
}
</script>

<style scoped>
</style>